import { render, staticRenderFns } from "./SupplyManager.vue?vue&type=template&id=70155de2&"
import script from "./SupplyManager.vue?vue&type=script&lang=ts&"
export * from "./SupplyManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports